import { handleMultilingualPrefix } from '@/utils/domainUtils';
import { APP_CONFIGURATION_ROUTE } from '@/constants/routes.constants';
import type { MieleApiErrorResponse } from './miele-api-service';
import type { ConfigurationResponse } from '@/types/shared-types';

export const getAppConfiguration = async (baseUrl?: string): Promise<ConfigurationResponse> => {
    const hostname = import.meta.env.VITE_HYBRIS_HOST
        ? import.meta.env.VITE_HYBRIS_HOST
        : baseUrl
        ? baseUrl
        : window.location.origin;
    const fetchUrl = handleMultilingualPrefix(APP_CONFIGURATION_ROUTE);
    const response = await fetch(`${hostname}${fetchUrl}`);
    const data = await response.json();

    if (!response.ok) {
        throw new Error((data as MieleApiErrorResponse).data);
        console.error('Unable to load VG global configuration.');
    }

    return data;
};
